import { ReactNode } from 'react';

export function renderMarkdownAsPlainText(body?: string | ReactNode) {
	if (!body) {
		return body;
	}

	const text = body.toString();

	// Remove titles (lines that start with #)
	const headers = text.toString().replace(/^\s*#+\s*(.*?)$/gm, '$1');

	// Remove image syntax ![...](...)
	const images = headers.replace(/!\[.*?\]\(.*?\)/g, '');

	// Remove links but keep the text [text](url) → "text"
	const links = images.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1');

	// Remove bold text (e.g., __text__)
	const bold = links.replace(/(__|\*\*)(.*?)\1/g, '$2');

	// Remove formatting characters (*, `, >, etc.)
	const plainText = bold.replace(/(\*|`|>|\\)|^\s+|\s+$|\n/g, '');

	return plainText.trim();
}
